var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.19 94.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.34,492.11h25.48l20,22.78-20,22.67H850.34l20-22.67Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.08 0 5 94.68 24.66 94.68 46.73 0 27.08 0",
    style: {
      fill: "#5928dc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M845.34,492.11h25.48l20,22.78-20,22.67H845.34l20-22.67Z",
    transform: "translate(-803.59 -492.11)",
    style: {
      fill: "#5928dc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.08 0 0 94.68 19.66 94.68 41.73 0 22.08 0",
    style: {
      fill: "#5928dc"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40dfee88fac1a99c60621931027c7801.svg";
export { ForwardRef as ReactComponent };